import { indiaFlag } from "./../../Public/assets";
import { Input } from "../ui/input";

const TextFormField = ({ label, id, type, value, onChange, onBlur, error }) => (
  <div>
    <label
      htmlFor={id}
      className="block text-[16px] font-geomanistRegular text-greyish mb-[4px] xl:mb-[9px] ml-2 flex-nowrap overflow-hidden whitespace-nowrap"
    >
      {label}
    </label>
    <Input
      id={id}
      name={id}
      type={type}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      className={`w-full text-blackShade !font-geomanistBold font-[12px] xl:font-[16px] px-2 xl:px-3 py-1 xl:py-2  ${
        error ? "border-red-500" : ""
      }`}
    />
    {error && (
      <p className="text-failed font-geomanistRegular  text-sm mt-1 ml-2">
        {error}
      </p>
    )}
  </div>
);
const MobileInput = ({ value, onChange, onBlur, error }) => (
  <div className="space-y-2">
    <label
      htmlFor="mobileNumber"
      className="block text-[16px] text-greyish mb-2 ml-2"
    >
      Mobile Number
    </label>
    <div className="flex">
      <div
        className={`flex items-center  text-blackShade px-3 border rounded-l bg-white border-r-0 ${
          error ? "border-red-500" : ""
        }`}
      >
        <img
          src={indiaFlag}
          alt="India flag"
          className="w-6 h-6 rounded-full"
        />
      </div>
      <Input
        id="mobileNumber"
        name="mobileNumber"
        type="number"
        maxLength={10}
        preContentIcon={"+91"}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={`rounded-l-none w-full  !font-geomanistBold px-3 py-2 ${
          error ? "border-red-500" : ""
        }`}
      />
    </div>
    {error && <p className="text-failed text-sm mt-1 ml-2">{error}</p>}
  </div>
);
export { TextFormField, MobileInput };
